module.exports = __webpack_public_path__ + "static/media/reflect4.5d55275f.svg";